import type { AssistedAffiliationStatus, SelectOption } from "./types";

export const STATUS_LABELS: Record<AssistedAffiliationStatus, string> = {
  DRAFT: "Borrador",
  IN_PROGRESS: "En proceso",
  PENDING_INFORMATION: "Información pendiente",
  COMMERCE_CREATED: "Comercio creado",
  REQUEST_CANCELLED: "Rechazado",
  CREATION_ERROR: "Error de creación",
};

export const STATUS_BY_LABEL: Record<string, AssistedAffiliationStatus> =
  Object.fromEntries(
    Object.entries(STATUS_LABELS).map(([code, label]) => [label, code])
  ) as Record<string, AssistedAffiliationStatus>;

export const EDITABLE_STATUSES: AssistedAffiliationStatus[] = (
  Object.keys(STATUS_LABELS) as AssistedAffiliationStatus[]
).filter((status) => status !== "COMMERCE_CREATED");

export const USER_SELECTABLE_STATUSES: AssistedAffiliationStatus[] = [
  "DRAFT",
  "PENDING_INFORMATION",
  "REQUEST_CANCELLED",
];

export const buildCreationStatusOptions = (
  currentLabel: string
): SelectOption[] => {
  const options = USER_SELECTABLE_STATUSES.map((status) => ({
    label: STATUS_LABELS[status],
    value: STATUS_LABELS[status],
  }));

  if (!currentLabel || options.some((option) => option.value === currentLabel)) {
    return options;
  }

  return [{ label: currentLabel, value: currentLabel, disabled: true }, ...options];
};

